import { Injectable, inject } from '@angular/core';

import { BottomSheetService as CoreBottomSheetService, MenuAction, MenuActionsService, OnFeatureInit } from '@frontend/vanilla/core';
import { firstValueFrom } from 'rxjs';

import { BottomSheetOverlayService } from './bottom-sheet-overlay.service';
import { BottomSheetConfig } from './bottom-sheet.client-config';
import { BottomSheetService } from './bottom-sheet.service';
import { ButtonComponent } from './sub-components/button.component';
import { LinkComponent } from './sub-components/link.component';

@Injectable()
export class BottomSheetBootstrapService implements OnFeatureInit {
    private config = inject(BottomSheetConfig);
    private bottomSheetService = inject(BottomSheetService);
    private coreBottomSheetService = inject(CoreBottomSheetService);
    private bottomSheetOverlayService = inject(BottomSheetOverlayService);
    private menuActionsService = inject(MenuActionsService);

    async onFeatureInit() {
        this.coreBottomSheetService.set(this.bottomSheetService);
        await firstValueFrom(this.config.whenReady);
        this.menuActionsService.register(MenuAction.TOGGLE_BOTTOM_SHEET, () => {
            this.bottomSheetOverlayService.toggle();
        });
        this.bottomSheetService.setBottomSheetComponent('default', LinkComponent);
        this.bottomSheetService.setBottomSheetComponent('button', ButtonComponent);
    }
}
